/**
 * Management → User Management。
 * 打开页面打 STATSIG.COMMON.VIEW，value=mgmt_user_management。
 *
 * 正在用（新版 refactor）：
 * - 点 Add user / Invite to this organization 打开邀请弹窗
 * - 点 New organization 打开创建弹窗
 * - Send invite 落库（INSERT）
 * - Create organization 落库（ORG_INSERT）
 * - Manage orgs → Save changes（ORGS_UPDATE）
 * - Edit 后 Confirm（UPDATE）
 * - Disable / Enable（STATUS，value=frozen|active）
 *
 * 已不算：搜索、列筛选、切 tab、Support、升级套餐、旧版 User Management。
 */
export enum MgmtUserManagementEvent {
    /**
     * 点 Add user 或 Invite to this organization，打开邀请弹窗。
     * value 与 metadata.type 相同：click_open_popup
     */
    ADD_USER_BUTTON = 'USER_MANAGEMENT_ADD_USER_BUTTON',
    /**
     * 点 New organization 打开创建弹窗。
     * value 与 metadata.type 相同：click_open_popup
     */
    NEW_ORG_BUTTON = 'USER_MANAGEMENT_NEW_ORG_BUTTON',
    /**
     * Send invite 落库。value 与 metadata.email 相同，为用户填写的邮箱。
     * metadata 另有 first_name、last_name、nmls_number，
     * 以及 targetCustomerIDs（所选组织 id 数组，可多个）
     */
    INSERT = 'USER_MANAGEMENT_INSERT',
    /** Create organization 落库。value 与 metadata.organization_name 相同，为用户填写的 Organization name */
    ORG_INSERT = 'USER_MANAGEMENT_ORG_INSERT',
    /** Manage orgs 弹窗点 Save changes */
    ORGS_UPDATE = 'USER_MANAGEMENT_ORGS_UPDATE',
    /**
     * Edit 后点 Confirm。value 与 metadata.email 相同，为该用户邮箱。
     * metadata.targetCustomerID 为当前编辑的组织 id，nmls_number 为 NMLS number
     */
    UPDATE = 'USER_MANAGEMENT_UPDATE',
    /**
     * 确认 Disable / Enable。value 与 metadata.status 相同：frozen|active（冻结|正常）
     * metadata 另有 targetUserAccount（该用户邮箱）、targetCustomerID（当前组织 id）
     */
    STATUS = 'USER_MANAGEMENT_STATUS',
}
